import Rellax from 'rellax';

new Rellax( '.hero-parallax', {
	speed: -2.5,
} );
